import React from 'react'
import LeftBar from '../../Components/LeftBar'
import IncomeComp from './IncomeComp'
import Dashnav from '../../Components/Dashnav'

function Income() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <IncomeComp/>      
        </div>
    </div>
  )
}

export default Income